<div
  class="drop-area"
  [ngClass]="{
    'drop-area--active': active,
    'drop-area--with-lead-info': maxFileSize != null || accept != null,
    'drop-area--no-border': noBorder,
  }"
  (click)="file.click()"
>
  <!-- Icon -->
  <div class="file-drop__icon">
    <div class="file"><i class="far fa-file"></i></div>
    <div class="plus"><i class="far fa-plus"></i></div>
  </div>

  <!-- Title -->
  <div class="drop-area__title">{{ 'fileDropArea.title' + (multiple ? '.plural' : '') | translate }}</div>

  <!-- Lead -->
  <div class="drop-area__lead">
    <span>{{ 'fileDropArea.lead' | translate }}</span>
  </div>

  @if (maxFileSize != null || accept != null) {
    <div class="drop-area__lead-info">
      @if (maxFileSize != null) {
        <span>{{
          'fileDropArea.lead.maxFileSize' | translate: { maxFileSize: maxFileSize | formatBytes }
        }}</span>
      }
      @if (accept != null && noAcceptDescription() === false) {
        <span>
          {{ 'fileDropArea.lead.accept' | translate: { accept: (acceptDescription | translate) || accept } }}
        </span>
      }
    </div>
  }

  <input
    class="d-none"
    id="file-drop-area__file"
    #file
    [accept]="accept"
    [multiple]="multiple"
    (change)="setFileFromInput(file.files)"
    type="file"
  />

  <!-- Drop handler -->
  <portal-file-drop
    [accept]="accept"
    [hasFile]="files.length > 0"
    [maxFileSize]="maxFileSize"
    [multiple]="multiple"
    (dragEnter)="setActive(true)"
    (dragLeave)="setActive(false)"
    (dropped)="setFile($event)"
    (rejected)="setRejectedFiles($event)"
    variant="plain"
  ></portal-file-drop>
</div>

@if (acceptInfo != null) {
  <small class="d-block mt-2">
    {{ acceptInfo | translate }}
  </small>
}

<!-- Current file -->
@if (activeFile()?.fileName && files.length === 0) {
  <div class="drop-area__files">
    <div class="drop-area__accepted-files">
      @if (preview == null) {
        <div class="drop-area__file">
          <div>
            <strong>{{ 'fileDropArea.currentFile' | portalTranslate }}</strong>
            <span class="ms-1 g-word-break-all">{{ activeFile().fileName }}</span>
            @if (clearable) {
              @if (progress == null) {
                <portal-icon-button
                  class="ms-auto"
                  (onClick)="removeCurrentFile()"
                  iconClass="far fa-times"
                ></portal-icon-button>
              }
            }
          </div>
        </div>
      } @else if (preview === 'image') {
        <div class="drop-area__image">
          <img [alt]="activeFile().fileName" [src]="imageUrl()" [width]="250" />
          <span>{{ activeFile().fileName }}</span>
          @if (clearable) {
            @if (progress == null) {
              <portal-icon-button
                class="drop-area__remove-image"
                [portalTippy]="'common.removeImage' | translate"
                (onClick)="removeCurrentFile()"
                iconClass="far fa-times"
              ></portal-icon-button>
            }
          }
        </div>
      }
    </div>
  </div>
}

<!-- Files -->
@if ((dropOnly === false && files.length > 0) || rejectedFiles?.files.length > 0) {
  <div class="drop-area__files">
    <!-- Accepted files -->
    <ul class="drop-area__accepted-files">
      @for (file of files; track file) {
        <li class="drop-area__file" [class.drop-area__file--show-progress]="progress != null">
          <div class="drop-area__progress" [style.width]="progress + '%'"></div>
          <span>{{ file.name }}: {{ file.size | formatBytes }}</span>
          @if (progress == null) {
            <portal-icon-button (onClick)="removeFile(file)" iconClass="far fa-times"></portal-icon-button>
          }
        </li>
      }
    </ul>
    <!-- Rejected files -->
    @if (rejectedFiles != null) {
      <portal-file-rejected-description
        class="drop-area__rejected-files"
        [acceptDescription]="acceptDescription"
        [clearable]="true"
        [multiple]="multiple"
        [noContext]="true"
        [rejectedFiles]="rejectedFiles"
        (clear)="removeRejectedFile($event)"
      ></portal-file-rejected-description>
    }
  </div>
}
